<script setup lang="ts">
import { ref, watch } from 'vue'
import type { CostCenter } from '../../stores/costCenter'

const props = defineProps<{
  center: CostCenter | null
  initialCode?: string
}>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'add', type: { code: string, name: string, description?: string }): void
}>()

const newType = ref({
  name: '',
  code: props.initialCode || '',
  description: ''
})

// Atualiza o código quando o initialCode mudar
watch(() => props.initialCode, (newCode) => {
  if (newCode) {
    newType.value.code = newCode
  }
})

const addType = () => {
  emit('add', {
    ...newType.value
  })
  newType.value = {
    name: '',
    code: '',
    description: ''
  }
}
</script>

<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
    <div class="bg-white p-6 rounded-lg w-full max-w-md">
      <h2 class="text-xl font-bold mb-4">
        Novo Tipo de Custo - {{ center?.name }}
      </h2>
      <form @submit.prevent="addType" class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700">Código</label>
          <input
            v-model="newType.code"
            type="text"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 bg-gray-100"
            required
            readonly
          />
          <p class="mt-1 text-sm text-gray-500">Código gerado automaticamente</p>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">Nome</label>
          <input
            v-model="newType.name"
            type="text"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            required
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">Descrição</label>
          <textarea
            v-model="newType.description"
            rows="3"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          ></textarea>
        </div>
        <div class="flex justify-end space-x-3">
          <button
            type="button"
            @click="emit('close')"
            class="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
          >
            Cancelar
          </button>
          <button
            type="submit"
            class="px-4 py-2 bg-primary-dark text-white rounded-md hover:bg-primary-dark/90"
          >
            Adicionar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>